<template>
  <el-dialog :visible.sync="show" :width="width" :modal="false" :close-on-click-modal="false" @close="cancle">
    <div style="text-align: center; font-size: 20px; margin-bottom: 20px">
      <!-- 在线申请试用产品 -->
      {{ title }}
    </div>
    <el-form size="small" :model="form" :rules="rules" ref="ruleForm" label-width="120px">
      <el-form-item label="试用产品" prop="productName" style="width: 90%">
        <el-input v-model="form.productName" :disabled="form.productName != '' && isProduc"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="askerName" style="width: 90%">
        <el-input v-model="form.askerName"></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="askerPhone" style="width: 90%">
        <el-input v-model="form.askerPhone"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="askerEmail" style="width: 90%">
        <el-input v-model="form.askerEmail"></el-input>
      </el-form-item>
      <el-form-item label="公司/单位" prop="companyName" style="width: 90%">
        <el-input v-model="form.companyName"></el-input>
      </el-form-item>
      <el-form-item label="重点需求描述" prop="questionDesp" style="width: 90%">
        <el-input type="textarea" :rows="5" v-model="form.questionDesp"></el-input>
      </el-form-item>
      <el-form-item>
        <div>
          <el-button style="width: 80%;" type="primary" @click="handleSubmitClick">确 定</el-button>
          <div style="font-size: 10px; color: #999999;line-height: 15px;margin-top: 10px;">请填写您的真实信息,我们会在收到申请后尽快与您联系</div>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { addConsult } from "@/api/consult"
export default {
  data() {
    return {
      show: false,
      form: {
        productId: undefined,
        productName: undefined,
        askerName: undefined,
        askerPhone: undefined,
        askerEmail: undefined,
        questionDesp: undefined,
        companyName: undefined
      },
      rules: {
        productName: [{ required: true, message: "请输入产品", trigger: "blur" }],
        askerName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        askerPhone: [
          { required: true, message: "请输入电话", trigger: "blur" },
        ],
        askerEmail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        questionDesp: [
          { required: true, message: "请输入重点需求描述", trigger: "blur" },
        ],
        companyName: [
          { required: true, message: "请输入公司/单位", trigger: "blur" },
        ],
      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    productId: {
      type: String
    },
    productName: {
      type: String
    },
    isProduc: {
      type: Boolean
    },
    title: {
      type: String,
      default: '产品咨询'
    }
  },
  computed: {
    width() {
      return this.$store.state.app.device == 'desktop' ? '500px' : `${document.body.clientWidth - 10}px`
    }
  },
  mounted() {
    this.show = this.dialogVisible
    this.$set(this.form, "productId", this.productId)
    this.$set(this.form, "productName", this.productName)
  },
  methods: {
    handleSubmitClick() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          addConsult(this.form).then(res => {
            if (res.code === 0) {
              this.$message.success("提交成功");
              this.show = false;
            }
          })
        }
      })
    },
    cancle() {
      this.$emit('cancel', false)
    }
  },
  watch: {
    dialogVisible(data) {
      this.show = data
    },
    productName(data) {
      this.shoform.productName = data
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ConsultDialog.vue